<template>
  <Modal v-model="subsidyDescriptionModal" :title="$t('key1003871')" width="1200" :transfer="false" @on-visible-change="subsidyDescriptionChange">
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <div class="mt10 mb10">
        {{
          $t('key1003883') + subsidyDetails.subsidyAmount + ' ' +
          (subsidyDetails.subsidyAmountCurrency ? subsidyDetails.subsidyAmountCurrency : '')
        }}
      </div>
    </div>
    <template #footer>
      <Button type="primary" @click="subsidyDescriptionModal = false">{{ $t('key1000316') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {isJSON, amountHandel, setConfigCharacters} from "@/utils/common";

export default {
  name: "subsidyDescriptionModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      subsidyDescriptionModal: false,
      subsidyAmountTypeList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003864')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003865')},
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003866')}
      ],
      originalConditionTypeData: [
        {code: 'CORE-YPOSR-001', value: 'goodsQuantity', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003855')},
        {code: 'CORE-YPOSR-003', value: 'shippingMethod', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867')},
        {code: 'CORE-YPOSR-004', value: 'shippingEfficiency', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003868')},
        {code: 'CORE-YPOSR-005', value: 'supplierMerchantId', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
        {code: 'CORE-YPOSR-002', value: 'subsidyObject', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003869')},
        {code: 'CORE-YPOSR-006', value: 'subsidyType', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003870')},
      ],
      deliveryMethodList: [
        {value: 1, name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003859')}`},
        {value: 2, name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003860')}`},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587')},
      ],
      typeValueList: [
        {value: 1, name: '≥'},
        {value: 2, name: '>'},
        {value: 3, name: '='},
        {value: 4, name: '<'},
        {value: 5, name: '≤'}
      ],
      tableColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003871'),
          key: 'ruleNameTitle',
          align: 'left',
          minWidth: 170
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003872'),
          key: 'subsidyConditions',
          align: 'left',
          minWidth: 240,
          render(h, params) {
            let ruleItems = params.row.ruleItems || [];
            let subsidyConditionsList = [];
            let list = [];
            let newList = ruleItems.filter((item) => {
              return !['CORE-YPOSR-002', 'CORE-YPOSR-006'].includes(item.ruleCode);
            });
            if (newList.length > 0) {
              newList.map((item) => {
                if (item.ruleItemParams) {
                  item.ruleItemParams.map((ele) => {
                    v.originalConditionTypeData.map((talg) => {
                      if (ele.name === talg.value) {
                        let data = JSON.parse(ele.value);
                        subsidyConditionsList.push({
                          type: ele.name,
                          title: talg.name,
                          symbol: v.typeValueList.filter((j) => {
                            return data.symbol === j.value;
                          })[0].name,
                          value: data.obj.value,
                          shipedTime: data.obj.shipedTime || ''
                        });
                      }
                    });
                  });
                }
              });
              if (subsidyConditionsList.length > 0) {
                let space = ' ';
                subsidyConditionsList.map((k, index) => {
                  let text = '';
                  if (k.type === 'shippingMethod') {
                    let txt = v.deliveryMethodList.filter((item) => {
                      return item.value === k.value;
                    })[0].name;
                    text = (index + 1) + '.' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003873') + txt;
                  }
                  if (k.type === 'supplierMerchantId') {
                    let txt = v.sepCommasFn(k.value);
                    text = (index + 1) + '.' + k.title + '： ' + txt.join('、');
                  }
                  if (k.type === 'shippingEfficiency') {
                    let value = amountHandel(k.value * 100);
                    text = `${index + 1}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003861')}${k.shipedTime}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003862')}${space}${k.title}${space}${k.symbol}${space}${value}%`;
                  }
                  if (k.type === 'goodsQuantity') {
                    text = `${index + 1}.${k.title}${space}${k.symbol}${space}${k.value}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003863')}`;
                  }
                  list.push(h('div', {
                    class: 'mt5 mb5'
                  }, text));
                });
              }
              return h('div', list);
            } else {
              return h('div', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003874'),
          key: 'queryRealityRule',
          align: 'left',
          minWidth: 240,
          render(h, params) {
            let ruleItems = params.row.ruleItems || [];
            let subsidyConditionsList = [];
            let list = [];
            let queryRealityRule = params.row.queryRealityRuleJsonBo;
            let newList = ruleItems.filter((item) => {
              return !['CORE-YPOSR-002', 'CORE-YPOSR-006'].includes(item.ruleCode);
            });
            if (newList.length > 0 && queryRealityRule) {
              newList.map((item) => {
                if (item.ruleItemParams) {
                  item.ruleItemParams.map((ele) => {
                    v.originalConditionTypeData.map((talg) => {
                      if (ele.name === talg.value) {
                        let values = JSON.parse(ele.value);
                        let val = queryRealityRule[talg.value];
                        subsidyConditionsList.push({
                          type: ele.name,
                          title: talg.name,
                          value: val,
                          shipedTime: values.obj.shipedTime || ''
                        });
                      }
                    });
                  });
                }
              });
              if (subsidyConditionsList.length > 0) {
                subsidyConditionsList.map((k, index) => {
                  let text = '';
                  if (k.type === 'shippingMethod') {
                    let txt = v.deliveryMethodList.filter((item) => {
                      return item.value === k.value;
                    })[0].name;
                    text = (index + 1) + '.' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003873') + txt;
                  }
                  if (k.type === 'supplierMerchantId') {
                    let txt = v.sepCommasFn(k.value);
                    text = (index + 1) + '.' + k.title + '： ' + txt.join('、');
                  }
                  if (k.type === 'shippingEfficiency') {
                    let value = amountHandel(k.value * 100);
                    text = `${index + 1}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003861')}${k.shipedTime}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003862')}${k.title}：${value}%`;
                  }
                  if (k.type === 'goodsQuantity') {
                    text = `${index + 1}.${k.title}：${k.value}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003863')}`;
                  }
                  list.push(h('div', {
                    class: 'mt5 mb5'
                  }, text));
                });
              }
              return h('div', list);
            } else {
              return h('div', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003875'),
          key: 'ruleActions',
          align: 'left',
          minWidth: 230,
          render(h, params) {
            let ruleActions = params.row.ruleActions || [];
            let title = '';
            if (ruleActions.length > 0) {
              let values = ruleActions.filter((item) => {
                return item.type === 'ymsSubsidyAutoRule';
              })[0].value;
              let data = JSON.parse(values);
              v.subsidyAmountTypeList.map((item) => {
                if (item.value === data.subsidyAmountType) {
                  title = item.name;
                }
              });
              return data.subsidyAmountType === 0 ? h('p', title) :
                h('div', [
                  h('p', {class: 'mb5 mt5'}, title),
                  data.subsidyAmountType === 1 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003876') + data.subsidyAmountPerOrder + ' ' + v.subsidyDetails.subsidyAmountCurrency) : '',
                  data.subsidyAmountType === 2 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003877') + data.subsidyAmountWithinOneKG + ' ' + v.subsidyDetails.subsidyAmountCurrency) : '',
                  data.subsidyAmountType === 2 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003878') + data.subsidyAmountPerKGOverOne + ' ' + v.subsidyDetails.subsidyAmountCurrency) : '',
                  data.subsidyAmountType === 2 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003879') + data.subsidyAmountCeilingPerOrder + ' ' + v.subsidyDetails.subsidyAmountCurrency) : '',
                ]);
            } else {
              return h('div', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675'),
          key: 'realityResult',
          align: 'left',
          minWidth: 110,
          render(h, params) {
            let realityResult = params.row.realityResult;
            let text = '-';
            if (realityResult) {
              text = realityResult + ' ' + v.subsidyDetails.subsidyAmountCurrency;
            }
            return h('span', text);
          }
        },
      ],
      tableData: [],
      subsidyDetails: {}
    };
  },
  methods: {
    // 初始化数据
    initSubsidyDescriptionData(ymsPickupOrderId) {
      let v = this;
      if (ymsPickupOrderId) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsPickupOrder_subsidyDetails + ymsPickupOrderId).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.subsidyDetails = data;
              v.handleData(data);
            }
            v.subsidyDescriptionModal = true;
          }
        });
      }
    },
    // 处理数据
    handleData(data) {
      let v = this;
      let querySubsidyDetailsBos = data.querySubsidyDetailsBos || [];
      let ymsLogs = data.ymsLogs || [];
      if (querySubsidyDetailsBos.length > 0) {
        querySubsidyDetailsBos.map((item) => {
          item['ruleNameTitle'] = item.parentAutoRuleId ? (aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003880') + item.ruleName) : (aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003881') + item.ruleName);

        });
        v.tableData = querySubsidyDetailsBos;
      }
      if (ymsLogs.length > 0) {
        ymsLogs.map((item) => {
          if (item.content && isJSON(item.content)) {
            let obj = JSON.parse(item.content);
            for (let key in obj) {
              item[key] = obj[key];
            }
          }
          if (item.operateType === aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001978')) {
            let obj = {
              ruleNameTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003882') + item.operateContent,
              ruleItems: [],
              ruleActions: [],
              queryRealityRuleJsonBo: [],
              realityResult: ''
            };
            v.tableData.push(obj);
          }
        });
      }
    },
    // 监听弹窗
    subsidyDescriptionChange(value) {
      if (!value) {
        this.tableData = [];
      }
    }
  }
};
</script>

<style scoped>

</style>